
import Vue from 'vue';

interface IData {
  profile: string;
}

export default Vue.extend({
  data(): IData {
    return {
      profile: this.$store.state.auth.user,
    };
  },
  mounted() {
    // Handle legacy urls here (this was widgets page before)
    // g -> group
    const group = this.$route.query.g;
    if (group) {
      this.$router.push({
        path: 'widgets/',
        query: Object.assign({}, this.$route.query, { group, g: undefined }),
      });
    }
  },
});
